import React, { useState, useRef, useEffect } from "react";

import "./styles.css";

import {
  Snackbar,
  Modal,
  Alert,
  Divider,
  Paper,
  Stack,
  Radio,
  InputAdornment,
  AlertTitle,
  Typography,
  Popper,
  FormControl,
  MenuItem,
  CircularProgress,
  Select,
  Button,
  Box,
  IconButton,
  Popover,
  Tooltip,
  TextField,
  Slider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
  Checkbox,
  FormControlLabel,
} from "@mui/material";

import { DataGrid, GridColDef, GridValueGetterParams } from "@mui/x-data-grid";

import CloseIcon from "@mui/icons-material/Close";

import api from "../../helpers/api.js";

import SearchIcon from "@mui/icons-material/Search";

import { useChallenge } from "../../contexts/ChallengeContext";

export default function UsersSelectionModal({
  mainButtonText,
  open,
  title,
  allowMultipleSelection = false,
  onSubmit = () => {},
  onClose,
  onSelect = () => {},
  hideFooter = false,
}) {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState();

  const loadedUsers = useRef([]);

  const [selectedIds, setSelectedIds] = useState([]);

  const [search, setSearch] = useState("");
  const REF_searchString = useRef();

  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const { currentChallenge } = useChallenge();

  useEffect(() => {
    if (open) {
      setSelectedIds([]);
      setSearch("");
      setRows([...loadedUsers.current]);
    }
  }, [open]);

  useEffect(() => {
    loadUsers();
  }, [search]);

  async function loadUsers() {
    try {
      const { data } = await api.get(
        "/customers?page=1&subscription_products=*&subscription_status=*&search_string=" +
          search?.trim()
      );

      if (!data?.users) return;

      loadedUsers.current = [...data.users];
      setRows([...data.users]);
    } catch (e) {
      console.log(e);
    }
  }

  function handleRowSelected(users) {
    if (allowMultipleSelection) {
      setSelectedIds([...users]);
    } else {
      setSelectedIds([users[1] || users[0]]);
    }

    const userId = users[1] || users[0];
    const userInfo = rows.filter((user) => user.id === userId)[0];
    onSelect(userInfo);
  }

  async function handleSubmit() {
    try {
      setLoading(true);
      const usersSelected = loadedUsers.current.filter((user) =>
        selectedIds.includes(user.id)
      );
      await onSubmit(usersSelected);
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  }
  function handleFilter(v) {
    const { value } = v.target;
    setSearch(value);
  }

  if (!open) return <></>;

  return (
    <div className="cm fade">
      <div className="modal-backdrop" onClick={onClose}></div>
      <div className="modal-content">
        <div className="modal-title px-3 py-1">
          <Typography variant="h4" component="h4">
            {title}
          </Typography>
          <IconButton children={<CloseIcon />} onClick={onClose} size="small" />
        </div>

        <div className="mt-2 mb-1 px-3">
          <TextField
            autoFocus
            value={search}
            onInput={handleFilter}
            color="primary"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            id="outlined-basic"
            fullWidth
            size="medium"
            label="Buscar participante"
            variant="outlined"
          />
        </div>
        <Divider />

        <div className="modal-body-content">
          {rows && (
            <DataGrid
              size="small"
              checkboxSelection
              onSelectionModelChange={handleRowSelected}
              selectionModel={selectedIds}
              rows={rows}
              columns={[
                {
                  field: "avatar",
                  headerName: "",
                  flex: 0,
                  width: 32,
                  renderCell: (params) => (
                    <img
                      src={params.row.avatar}
                      style={{
                        width: "28px",
                        height: "28px",
                        borderRadius: "50%",
                      }}
                    />
                  ),
                },
                {
                  field: "username",
                  headerName: "Nome",
                  flex: 2,
                },
                {
                  field: "phone",
                  headerName: "Celular",
                  minWidth: 170,
                },
              ]}
              initialState={{
                pagination: {
                  paginationModel: { page: 0, pageSize: 5 },
                },
              }}
              pageSizeOptions={[5, 10]}
            />
          )}
        </div>

        {!hideFooter && (
          <div className="modal-bottom px-3 py-1">
            <Divider className="modal-bottom-divider" />
            <Typography variant="span" component="span">
              {title}
            </Typography>
            <div className="main-actions">
              <Button onClick={onClose} size="small" variant="text">
                cancelar
              </Button>
              <Button
                disabled={!selectedIds[0] || loadingSubmit}
                onClick={handleSubmit}
                size="small"
                variant="contained"
                color="secondary"
              >
                {mainButtonText}
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
